import React from 'react';
import { Select, Spin, Tooltip, Button, Icon, Modal } from 'antd';
import ArticulosRequest from '../../services/Articulos';
import { openNotification } from '../../util/notificaciones';
import BaseComponent from "../Common/BaseComponent";

const { Option } = Select;
const { confirm } = Modal;

/**
 * Clase para ver el proceso de formulario de categorizar
 */
export default class CategorizarArticulos extends BaseComponent {
    state = {
        arrArticulosCategorizar: [],
        guardando: false,
        bloquearBotones: true,
        categoriaSelected: null,
        cancelModalConfirm: false,
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if ((this.props.arrArticulos !== prevProps.arrArticulos)) {
            state.categoriaSelected !== null ? state.bloquearBotones = false : state.bloquearBotones = true
            state.arrArticulosCategorizar = this.props.arrArticulos
            this.setState(state)
        }
    }

    /**
     * Comportamiento all hacer clic en categorizar artículos
     * @param: nada.
     * @return: nada.
     */
    categorizarArts = () => {
        let state = { ...this.state }
        ArticulosRequest.CategorizarArticulos(state.categoriaSelected, this.props.arrArticulos)
            .then(response => {
                state.guardando = false;
                state.categoriaSelected = null;
                openNotification("Los artículos se han categorizado correctamente.", "Artículos categorizados", true)
                this.setState(state, this.props.esconderModal(true))
            })
            .catch(err => {
                this.setState({ bloquearBotones: false, guardando: false })
                openNotification(
                    err.response.data.cuerpo,
                    err.response.data.titulo,
                    false
                )
            })
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de generar un pedido.
     */
    handleCancel = () => {
        this.props.esconderModal(false);
        this.setState({ categoriaSelected: null, bloquearBotones: true })
    }

    /**
     * Comportamiento al cambiar la categoría
     * @param: value. id de categoría
     * @return: nada.
     */
    onChangeCategoria = (value) => {
        let state = { ...this.state }
        state.categoriaSelected = value === undefined ? null : value;
        if (value === undefined || value === null) {
            state.bloquearBotones = true
        } else {
            state.bloquearBotones = false
        }

        this.setState(state)
    }

    /**
     * Comportamiento al confirmar categorización
     * @param: nada.
     * @return: nada.
     */
    showConfirm = () => {
        confirm({
            id: "boton-aceptar-confirmacion-articulos",
            title: 'Confirmar categorización',
            content: this.props.arrArticulos.length === 1 ? "Se va a categorizar 1 artículo." : "Se van a categorizar " + this.props.arrArticulos.length + " artículos.",
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            onOk: () => {
                this.setState({ guardando: true, bloquearBotones: true }, this.categorizarArts())
            },
        });
    }

    render() {
        return (
            <div>
                <Modal
                    title={"Categorizar artículos"}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    onOk={this.categorizarArts}
                    width={this.state.isPos ? "80%" : "35%"}
                    maskClosable={false}
                    confirmLoading={true}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-articulos"
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className="btnVerCrearGuardar"
                                key="submit"
                                id="boton-categorizar-form-articulos"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={this.showConfirm}
                            >
                                Guardar
                            </Button>,
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.guardando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Tooltip placement="top" title="Seleccione una categoría">
                            <div className="center">Categoría:</div>
                            <Select
                                allowClear={true}
                                style={{ width: '100%' }}
                                notFoundContent='No hay opciones'
                                placeholder="Seleccionar..."
                                defaultValue={null}
                                showSearch
                                id="select-elegir-categoria-form"
                                defaultActiveFirstOption={false}
                                optionFilterProp="children"
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                value={this.state.categoriaSelected}
                                onChange={this.onChangeCategoria}
                            >
                                <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                {
                                    this.props.arrCategorias.length > 0 &&
                                    this.props.arrCategorias.map(obj => {
                                        return (
                                            <Option
                                                key={obj.id}
                                                value={obj.id}>
                                                {obj.descripcion}
                                            </Option>
                                        )
                                    })
                                }
                            </Select>
                        </Tooltip>
                    </Spin>
                </Modal>
            </div >
        )
    }
}